// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import React from "react";
import { connect } from "react-redux";
import * as cartSelectors from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { css } from "styled-components";
import { spacingStyles } from "@toolkit/Themes/common/mixins";

const enum fields {
    htmlContent = "htmlContent",
}

interface RequireQuoteProductsWarningProps extends WidgetProps {
    fields: {
        [fields.htmlContent]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
});

type Props = RequireQuoteProductsWarningProps & ReturnType<typeof mapStateToProps>;

export interface RequireQuoteProductsWarningStyles {
    infosBox?: InfosBoxProps;
}

export const requireQuoteProductsWarningStyles: RequireQuoteProductsWarningStyles = {
    infosBox: {
        type: "warning",
        extendedStyles: {
            wrapper: {
                css: css`
                    p {
                        ${spacingStyles("0", "0")}
                    }
                `,
            },
        },
    },
};

const styles = requireQuoteProductsWarningStyles;

const RequireQuoteProductsWarning = ({ cart, fields: { htmlContent } }: Props) => {
    if (!cart) {
        return null;
    }

    const hasQuoteRequiredProducts = cartSelectors.hasQuoteRequiredProducts(cart);
    const hasOnlyQuoteRequiredProducts = cartSelectors.hasOnlyQuoteRequiredProducts(cart);

    return hasQuoteRequiredProducts && !hasOnlyQuoteRequiredProducts ? (
        <InfosBox {...styles.infosBox}>{parse(htmlContent, parserOptions)}</InfosBox>
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RequireQuoteProductsWarning),
    definition: {
        displayName: "Require Quote Products Warning",
        group: "Cart",
        icon: "circle-i",
        fieldDefinitions: [
            {
                name: fields.htmlContent,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
